import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ENERGIES = ['chill', 'upbeat', 'groovy', 'dance'];

export const formatDuration = (ms) => {
  const s = Math.max(0, Math.floor((ms || 0) / 1000));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
};

// Read playback duration client-side so the server never has to decode audio.
export const readAudioDuration = (file) =>
  new Promise((resolve) => {
    try {
      const el = document.createElement('audio');
      el.preload = 'metadata';
      el.src = URL.createObjectURL(file);
      el.addEventListener('loadedmetadata', () => {
        resolve(Math.floor((el.duration || 0) * 1000));
        URL.revokeObjectURL(el.src);
      });
      el.addEventListener('error', () => resolve(0));
    } catch {
      resolve(0);
    }
  });

// Chunked upload: init → PUT chunks in order → complete. Bypasses ingress
// body-size limits so large licensed files (WAV/high-bitrate) upload cleanly.
export async function uploadTrackChunked(file, meta, onProgress) {
  const init = await axios.post(
    `${API}/catalog/uploads/init`,
    { filename: file.name, content_type: file.type || 'audio/mpeg' },
    { withCredentials: true }
  );
  const { upload_id: uploadId, chunk_size: chunkSize } = init.data;
  const size = file.size;
  let sent = 0;
  for (let start = 0; start < size; start += chunkSize) {
    const chunk = file.slice(start, Math.min(start + chunkSize, size));
    // eslint-disable-next-line no-await-in-loop
    await axios.put(`${API}/catalog/uploads/${uploadId}/chunk`, chunk, {
      headers: { 'Content-Type': 'application/octet-stream' },
      withCredentials: true,
    });
    sent += chunk.size;
    if (onProgress) onProgress(Math.min(99, Math.round((sent / size) * 100)));
  }
  const res = await axios.post(`${API}/catalog/uploads/${uploadId}/complete`, meta, {
    withCredentials: true,
  });
  if (onProgress) onProgress(100);
  return res.data;
}
